import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';

import App from /***APP_PATH***/'./apps-inline/home-wui-mt/App'/***APP_PATH***/; 

//validate that the user in not using internet explorer
import { internetExplorerCheck } from './helpers/he-general';
internetExplorerCheck();


if (!window.heRenderAppFunctions){
    window.heRenderAppFunctions={}
}

window.heRenderAppFunctions[/***APP_NAME***/'home-wui-mt'/***APP_NAME***/] = (index)=>{
    const blockIndex = index || 0;
    const rootDiv = document.getElementsByClassName('he-app-root')[blockIndex]
    ReactDOM.render(
        <App blockIndex={blockIndex}/>, 
        rootDiv
    );
}

